export default __webpack_public_path__ + "static/media/pdam.4bb4c6b1.png";